var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadFilled = function SvgDownloadFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "none",
    viewBox: "0 0 12 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.097.722a.535.535 0 0 0-.542.542v3.792H2.57c-.406 0-.609.496-.316.79l3.431 3.43a.45.45 0 0 0 .61 0l3.43-3.43c.293-.294.09-.79-.316-.79H7.444V1.264a.55.55 0 0 0-.541-.542zm6.68 8.486a.55.55 0 0 0-.54-.541H7.917L6.812 9.773a1.13 1.13 0 0 1-1.647 0L4.059 8.667H.764a.535.535 0 0 0-.542.541v2.528c0 .316.226.542.542.542h10.472a.535.535 0 0 0 .542-.542zM8.98 11.194a.453.453 0 0 1-.451.452.453.453 0 0 1-.452-.452.453.453 0 0 1 .903 0m1.445 0a.453.453 0 0 1-.452.452.453.453 0 0 1-.451-.452c0-.248.203-.451.451-.451s.452.203.452.451"
  })));
};
export default SvgDownloadFilled;